var FileType;
(function (FileType) {
    FileType["Image"] = "image";
    FileType["Video"] = "video";
    FileType["Audio"] = "audio";
    FileType["CommonFile"] = "object";
})(FileType || (FileType = {}));
var FileExtKey;
(function (FileExtKey) {
    // 公共字段
    FileExtKey["Uri"] = "s:file_ext_key_uri";
    FileExtKey["Type"] = "s:file_ext_key_type";
    FileExtKey["AppId"] = "s:file_ext_key_source_app_id";
    FileExtKey["NeedEncrypt"] = "s:file_ext_key_need_encrypt";
    FileExtKey["EncryptUri"] = "s:file_ext_key_encrypt_uri";
    FileExtKey["Vid"] = "s:file_ext_key_vid";
    FileExtKey["FileName"] = "s:file_ext_key_file_name";
    // 图片
    FileExtKey["ImgHeight"] = "s:file_ext_key_original_height";
    FileExtKey["ImgWidth"] = "s:file_ext_key_original_width";
    FileExtKey["ImgThumbHeight"] = "s:file_ext_key_thumb_height";
    FileExtKey["ImgThumbWidth"] = "s:file_ext_key_thumb_width";
    FileExtKey["ImgThumbUrl"] = "s:file_ext_key_thumb_url";
    FileExtKey["ImgPreviewUrl"] = "s:file_ext_key_preview_url";
    FileExtKey["ImgPreviewHeight"] = "s:file_ext_key_preview_height";
    FileExtKey["ImgPreviewWidth"] = "s:file_ext_key_preview_width";
    // 加密后的字段
    FileExtKey["ImgPreviewEncryptUrl"] = "s:file_ext_key_preview_encrypt_url";
    FileExtKey["ImgThumbEncryptUrl"] = "s:file_ext_key_thumb_encrypt_url";
    FileExtKey["ImgUseImageX"] = "s:file_ext_key_use_imagex";
    FileExtKey["ImgSuffix"] = "s:file_ext_key_img_suffix";
    // 视频
    FileExtKey["VideoCoverUri"] = "s:file_ext_key_video_cover_uri";
    FileExtKey["VideoCoverUrl"] = "s:file_ext_key_video_cover_url";
    FileExtKey["VideoDuration"] = "s:file_ext_key_video_duration";
    FileExtKey["VideoWidth"] = "s:file_ext_key_video_width";
    FileExtKey["VideoHeight"] = "s:file_ext_key_video_height";
    // 音频
    FileExtKey["AudioDuration"] = "s:file_ext_key_audio_duration"; // 音频长度
})(FileExtKey || (FileExtKey = {}));
var FileExtTypeValue;
(function (FileExtTypeValue) {
    FileExtTypeValue["Image"] = "file_ext_value_type_image";
    FileExtTypeValue["Video"] = "file_ext_value_type_video";
    FileExtTypeValue["Audio"] = "file_ext_value_type_audio";
    FileExtTypeValue["Object"] = "file_ext_value_type_object";
    FileExtTypeValue["File"] = "file_ext_value_type_file";
})(FileExtTypeValue || (FileExtTypeValue = {}));
/** @internal */
var ImageTplvType;
(function (ImageTplvType) {
    ImageTplvType["Obj"] = "tplv-obj";
    ImageTplvType["Resize"] = "tplv-resize";
})(ImageTplvType || (ImageTplvType = {}));
/** @internal */
const ImageTplvFormat = 'image';
/** @internal */
const MultimediaPluginConsts = {
    vsdkVersion: 'v5',
    uploadRegion: 'cn-north-1'
};

export { FileExtKey, FileExtTypeValue, FileType, ImageTplvFormat, ImageTplvType, MultimediaPluginConsts };
//# sourceMappingURL=interfaces.js.map
